module.exports = __webpack_public_path__ + "media/images/manifest/microbius-384-fe57f040f1be88ba90cf4793b60a9395.png";